import { useFormik } from 'formik';
import { Props } from './types';

import * as Yup from 'yup';
import * as S from './styles';
import { useEffect } from 'react';

export const FormQueue = ({
  tablePeople,
  loading,
  getWaitLineTime,
  submit,
  isQrCodeGeneric,
  canSeeBirthDateField,
  canSeeEmailField,
  prohibitedTerms,
}: Props) => {
  const schema = Yup.object().shape({
    people: Yup.number().required('A quantidade de pessoas é obrigatória'),
    name: Yup.string()
      .trim()
      .matches(
        /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/,
        'O nome contém caracteres ou termos não aceitos.'
      )
      .max(40, 'O nome deve ter no máximo 40 caracteres.')
      .test(
        'prohibited-terms',
        'O nome contém caracteres ou termos não aceitos.',
        (value) => {
          if (!value) return true;

          return !prohibitedTerms.some((term) =>
            value.toLowerCase().includes(term)
          );
        }
      )
      .required('O nome é obrigatório'),
    email: isQrCodeGeneric
      ? Yup.string().email('Informe um email válido').trim()
      : Yup.string()
          .email('Informe um email válido')
          .trim()
          .required('O email é obrigatório'),
    mobile: Yup.string().trim().required('O telefone é obrigatório'),
    birthdate: canSeeBirthDateField
      ? Yup.string().trim().required('A data de nascimento é obrigatória')
      : Yup.string().trim(),
    info: Yup.string().trim(),
    accepted_marketing_agreement: Yup.boolean(),
  });

  const { values, handleChange, handleSubmit, errors, touched } = useFormik({
    initialValues: {
      people: isQrCodeGeneric ? 1 : 0,
      name: '',
      email: '',
      mobile: '',
      birthdate: '',
      info: '',
      accepted_marketing_agreement: true,
    },
    validationSchema: schema,
    onSubmit: (values) => {
      submit({
        ...values,
        mobile: `55${values.mobile.replace(/[\W_]+/g, '')}`,
      });
    },
  });

  useEffect(() => {
    if (values.people) getWaitLineTime({ people: values.people });
  }, [values.people]);

  const formikProps = (
    field: Exclude<keyof typeof values, 'accepted_marketing_agreement'>
  ) => ({
    value: values[field],
    error: touched[field] && errors[field] ? errors[field] : '',
    onChange: handleChange(field),
  });

  return (
    <S.Container>
      <S.TitleSpan>Adicione seus dados abaixo para entrar na fila</S.TitleSpan>
      <S.WrapperForm>
        <form onSubmit={handleSubmit}>
          <S.SelectWrapper required>
            <label>Número de pessoas</label>
            <select {...formikProps('people')}>
              <option value={0} disabled selected hidden>
                Selecionar
              </option>
              {tablePeople.map((people) => (
                <option key={people} value={people}>
                  {`${people} ${people > 1 ? 'pessoas' : 'pessoa'}`}
                </option>
              ))}
            </select>
          </S.SelectWrapper>
          <S.Input
            label="Nome completo"
            name="name"
            required
            {...formikProps('name')}
          />
          {canSeeEmailField && (
            <S.Input
              label="Email"
              name="email"
              required
              {...formikProps('email')}
            />
          )}
          <S.WrapperInputWithInfo>
            <S.Input
              label="Celular"
              name="mobile"
              mask={[
                {
                  mask: '(00) 00000-0000',
                },
              ]}
              required
              {...formikProps('mobile')}
            />
            <span>
              ATENÇÃO! Vamos usar esse contato para te chamar, via SMS, quando
              chegar sua vez na fila
            </span>
          </S.WrapperInputWithInfo>
          {canSeeBirthDateField && (
            <S.Input
              label="Data de nascimento"
              name="birthdate"
              type="date"
              required
              {...formikProps('birthdate')}
            />
          )}
          <S.WrapperInputWithInfo>
            <S.Input label="Observação" name="info" {...formikProps('info')} />
            {!isQrCodeGeneric ? (
              <span>Pedido sujeito a disponibilidade</span>
            ) : null}
          </S.WrapperInputWithInfo>
          <S.SmallParagraph>
            Ao entrar na fila, você também declara que aceita os{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="http://help.getinapp.com.br/customer/terms"
            >
              termos
            </a>{' '}
            e{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="http://help.getinapp.com.br/privacy"
            >
              políticas
            </a>{' '}
            do Get In.
          </S.SmallParagraph>
          <S.CustomButton type="submit" loading={loading}>
            Entrar na fila
          </S.CustomButton>
        </form>
      </S.WrapperForm>
    </S.Container>
  );
};
